var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.0547 11.2974C22.0516 12.0865 21.7272 12.8422 21.1526 13.3991C20.578 13.956 19.7999 14.2687 18.9888 14.2687H3.70587C2.89583 14.2687 2.11897 13.9556 1.54618 13.3984C0.973399 12.8412 0.651611 12.0855 0.651611 11.2974L0.651611 2.9712C0.651611 2.18318 0.973399 1.42744 1.54618 0.870224C2.11897 0.313009 2.89583 -3.05175e-05 3.70587 -3.05175e-05L18.9888 -3.05175e-05C19.7999 -3.61783e-05 20.578 0.312643 21.1526 0.869535C21.7272 1.42643 22.0516 2.18215 22.0547 2.9712V11.2974ZM9.14083 9.6932L14.9474 6.77845L9.14083 3.84111V9.6932Z","fill":"#272525"}));
}

Youtube.defaultProps = {"width":"23","height":"15","viewBox":"0 0 23 15","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
